export enum ApprovalStatusEnum {
    None = 'None',
    Approved = 'Approved',
    Rejected = 'Rejected',
    RevisionsRequested = 'RevisionsRequested',
}
